import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useNotify, Button, useMutation } from "react-admin";

interface IPostCashReceiptsButton {
  id: number;
  number: string;
}

const PostCashReceiptsButton = ({ id, number }: IPostCashReceiptsButton) => {
  const [open, setOpen] = useState<boolean>(false);
  const notify = useNotify();

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    cancelButton: {
      backgroundColor: "#eeeeee",
      color: "black",
    },
  });

  const classes = useStyles();

  const [handleChangeStatusCommercial, { loading }] = useMutation(
    {
      type: "customCreate",
      resource: `cashReceipts/${id}/post`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully approve the payment.`, "info");
        window.location.reload();
      },
      onFailure: (error) => {
        notify(
          `Failed approve the payment, error: ${error.message}`,
          "warning"
        );
      },
    }
  );

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button label={`Approve`} onClick={handleOpenDialog} />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">Approval Confirmation</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure want to approve this Bank Transfer with Invoices{" "}
            {number} ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleChangeStatusCommercial}
            color="primary"
            undoable={false}
            label={loading ? `Loading...` : `Yes`}
            disabled={loading}
          />
          <Button
            onClick={handleClose}
            color="secondary"
            label="Cancel"
            className={classes.cancelButton}
            disabled={loading}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default PostCashReceiptsButton;
